import React from 'react'
import DatePicker from '../genericComponents/DatePicker'
import s from './HotelDateInput.less'

const HotelDateInput = ({ label, date, picker, ariaLabel = null }) => {
  return (
    <div className={s.container}>
      {picker ? (
        <DatePicker className={s.picker} value={date} label={label} ariaLabel={ariaLabel} {...picker} />
      ) : (
        <div className={s.date}>{date}</div>
      )}
    </div>
  )
}

export default HotelDateInput
